export const callDirections = {
  incomming: 'incomming',
  outgoing: 'outgoing',
};

export const callDirectionsText = new Map([
  [null, 'Линия свободна'],
  [callDirections.incomming, 'Входящий вызов от:'],
  [callDirections.outgoing, 'Исходящий вызов на номер:'],
]);
